import styles from './EmptyPreviews.module.css';

export const EmptyPreviews = () => <div className={styles['preview-empty']}>Список пуст</div>;
